import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { GameController, CheckCircle, Warning } from '@phosphor-icons/react';
import { getUser, updateUserData } from '@/utils/auth';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided');
      return;
    }

    axios.get(`${API}/auth/verify-email?token=${token}`)
      .then((res) => {
        setStatus('success');
        setMessage(res.data.message);
        // Update local user data if logged in
        const user = getUser();
        if (user) updateUserData({ email_verified: true });
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'Verification failed');
      });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6">
      <div className="w-full max-w-md text-center">
        <div className="flex justify-center mb-4">
          <div className="bg-[#0047FF] p-4">
            <GameController size={48} weight="fill" color="#FFFFFF" />
          </div>
        </div>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-[#09090B] mb-8">
          DashLink Gaming
        </h1>

        {status === 'verifying' && (
          <div className="p-6 bg-[#FAFAFA] border border-[#E4E4E7]">
            <div className="w-12 h-12 border-4 border-[#0047FF] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-[#71717A]">Verifying your email...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="p-6 bg-green-50 border border-green-200" data-testid="verify-success">
            <CheckCircle size={48} weight="fill" className="mx-auto text-green-600 mb-3" />
            <h3 className="font-heading text-xl font-bold text-green-800 mb-2">Email Verified! 🎉</h3>
            <p className="text-sm text-green-700 mb-4">{message}</p>
            <Button
              onClick={() => { window.location.href = '/dashboard'; }}
              className="bg-[#0047FF] hover:bg-[#0037CC] text-white"
              data-testid="go-to-dashboard-button"
            >
              Go to Dashboard
            </Button>
          </div>
        )}

        {status === 'error' && (
          <div className="p-6 bg-red-50 border border-red-200" data-testid="verify-error">
            <Warning size={48} weight="fill" className="mx-auto text-red-600 mb-3" />
            <h3 className="font-heading text-xl font-bold text-red-800 mb-2">Verification Failed</h3>
            <p className="text-sm text-red-700 mb-4">{message}</p>
            <Button
              onClick={() => navigate('/auth')}
              variant="outline"
              className="border-[#E4E4E7]"
            >
              Back to Login
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
